import { render } from "./AssStudentMaster.vue?vue&type=template&id=8b4ee58a&scoped=true"
import script from "./AssStudentMaster.vue?vue&type=script&lang=js"
export * from "./AssStudentMaster.vue?vue&type=script&lang=js"

import "./AssStudentMaster.vue?vue&type=style&index=0&id=8b4ee58a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b4ee58a"]])

export default __exports__